<app-page-header subtitle="Verkeersmaatregelen">
    @if ((Features.VkmExcelExport | hasFeature) && groupedWorkorders && fcSelectedProjects.value?.length > 0) {
        <button
            class="menu-button"
            [disabled]="generatingExcel"
            (click)="excel()"
            print-pdf
            color="primary"
            mat-icon-button>
            @if (!generatingExcel) {
                <mat-icon fontSet="fa-regular" fontIcon="fa-file-excel"></mat-icon>
            } @else {
                <mat-icon class="fa-spin" fontSet="fas" fontIcon="fa-spinner"></mat-icon>
            }
        </button>
    }
</app-page-header>

<div class="container">
    <div class="row justify-content-center">
        <div class="col-6 d-flex pb-2 flex-column justify-content-center">
            <mat-checkbox [formControl]="fcGroupByProject">Groepeer per project</mat-checkbox>
        </div>
        <div class="col-md-12">
            <mat-form-field class="w-100" appearance="fill">
                <mat-label>Zoeken...</mat-label>
                <input
                    [formControl]="fcSearch"
                    matInput
                    placeholder="Zoeken op project, opdrachtgever, locatie of type"
                    value="Sushi" />
            </mat-form-field>
        </div>
        <div class="col-6 d-flex justify-content-center align-items-end pb-2 flex-column">
            <mat-checkbox [formControl]="fcShowHistory">Toon verleden</mat-checkbox>
        </div>
    </div>

    <table class="table table-center table-hover" [class.table-last-col]="groupedWorkorders">
        <tr>
            <th class="project-col">Project</th>
            <th class="description-col">Beschrijving</th>
            <th class="contractor-col">Opdrachtgever</th>
            <th class="location-col">Locatie</th>
            @if (!groupedWorkorders) {
                <th class="type-col">Type</th>
            }
            <th class="date-col">Datum</th>
            @if (groupedWorkorders) {
                <th class="checkbox-col">
                    <mat-checkbox
                        [checked]="
                            groupedWorkorders?.length > 0 &&
                            fcSelectedProjects.value?.length === groupedWorkorders.length
                        "
                        [indeterminate]="
                            fcSelectedProjects.value?.length > 0 &&
                            fcSelectedProjects.value?.length < groupedWorkorders.length
                        "
                        (change)="toggleAllSelection($event)"
                        (click)="$event.stopPropagation()">
                    </mat-checkbox>
                </th>
            }
        </tr>
        @if (!groupedWorkorders) {
            @for (workorder of workorders; track workorder) {
                <tr class="curpoint" [class.paid]="workorder['status_key'] === VkmStatus.VkmAfgerekend">
                    <td class="project-col" (click)="open(workorder, $event)">
                        {{ workorder.afas_project_id }}
                    </td>
                    <td class="description-col" (click)="open(workorder, $event)">
                        {{ workorder.description }}
                    </td>
                    <td class="contractor-col" (click)="open(workorder, $event)">
                        {{ workorder.contractor }}
                    </td>
                    <td class="location-col" (click)="open(workorder, $event)">
                        {{ workorder.location }}
                    </td>
                    <td class="type-col" (click)="open(workorder, $event)">
                        {{ workorder.type }}
                    </td>
                    <td class="date-col" (click)="open(workorder, $event)">
                        {{ workorder.begindate | date: 'd MMM yyyy' }}
                    </td>
                </tr>
            }
        } @else {
            @for (group of groupedWorkorders; track group) {
                <tr class="curpoint" [class.paid]="group.workorders[0]['status_key'] === VkmStatus.VkmAfgerekend">
                    <td class="project-col" (click)="openGrouped(group, $event)">
                        {{ group.afas_project_id }}
                    </td>
                    <td class="description-col" (click)="openGrouped(group, $event)">
                        {{ group.description }}
                    </td>
                    <td class="contractor-col" (click)="openGrouped(group, $event)">
                        {{ group.contractor }}
                    </td>
                    <td class="location-col" (click)="openGrouped(group, $event)">
                        {{ group.location }}
                    </td>
                    @if (!groupedWorkorders) {
                        <td class="type-col" (click)="openGrouped(group, $event)">
                            {{ group.type }}
                        </td>
                    }
                    <td class="date-col" (click)="openGrouped(group, $event)">
                        @if (group.minDate.getTime() === group.maxDate.getTime()) {
                            <span>
                                {{ group.minDate | date: 'd MMM yyyy' }}
                            </span>
                        }
                        @if (group.minDate.getTime() !== group.maxDate.getTime()) {
                            <span>
                                {{ group.minDate | date: 'd MMM' }} - {{ group.maxDate | date: 'd MMM yyyy' }}
                            </span>
                        }
                    </td>
                    <td class="checkbox-col">
                        <mat-checkbox
                            [checked]="isProjectSelected(group.planning_id)"
                            (change)="toggleProjectSelection(group.planning_id, $event)"
                            (click)="$event.stopPropagation()">
                        </mat-checkbox>
                    </td>
                </tr>
            }
        }
    </table>
</div>
@if (Functionalities.VkmManagement | hasFunctionality) {
    <div class="button-wrapper">
        <div class="container-xl">
            <div class="buttons">
                <button mat-raised-button color="primary" routerLink="/vkm/new">
                    Toevoegen <i class="fas fa-plus"></i>
                </button>
            </div>
        </div>
    </div>
}
